export default {
  title: {
    en: 'About Scentbird',
  },
  aboutUs: {
    en: 'About Us',
  },
  bloggerProgram: {
    en: 'Blogger Program',
  },
  affiliateProgram: {
    en: 'Affiliate Program',
  },
  forPress: {
    en: 'For Press',
  },
  blog: {
    en: 'Blog',
  },
  contactUs: {
    en: 'Contact Us',
  },
  faq: {
    en: 'Help',
  },
  careers: {
    en: 'Careers',
  },
  reviews: {
    en: 'Reviews',
  },
}
